import { Grid, IconButton } from "@mui/material";
import React, { useState } from "react";
import { BsDashLg } from "react-icons/bs";
import { useSwipeable } from "react-swipeable";
import contact_banner from "../../assets/contact_banner.webp";
import "../../components/mainstyling/mainstyling.css";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { IoIosCheckmark } from "react-icons/io";

import renov1 from "../../assets/renov1.webp";

import { services_list } from "../../components/utils/ServicesCardUtils";
import { IoLocationOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const images = services_list.map((item, index) => item.images[index]);

const ContactPage = () => {
  const navigate = useNavigate();
  const [currentIndexList, setCurrentIndexList] = useState(
    services_list.map(() => 0)
  );
  const nextSlide = (mainIndex) => {
    setCurrentIndexList((prevIndexList) => {
      const updatedIndexList = [...prevIndexList];
      updatedIndexList[mainIndex] =
        (prevIndexList[mainIndex] + 1) % services_list[mainIndex].images.length;
      return updatedIndexList;
    });
  };

  const prevSlide = (mainIndex) => {
    setCurrentIndexList((prevIndexList) => {
      const updatedIndexList = [...prevIndexList];
      updatedIndexList[mainIndex] =
        (prevIndexList[mainIndex] -
          1 +
          services_list[mainIndex].images.length) %
        services_list[mainIndex].images.length;
      return updatedIndexList;
    });
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => nextSlide(currentIndexList),
    onSwipedRight: () => prevSlide(currentIndexList),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });
  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
      >
        <Grid item xs={12} md={12} lg={12}>
          <div className="def-banner-image-container">
            <div className="perma-banner-wrapper">
              <div className="banner-holder">
                <img src={contact_banner} alt="" className="contact-banner" />
              </div>
            </div>
          </div>
        </Grid>

        <Grid item xs={10} md={10} lg={10}>
          <div className="section-teller-container">
            <div className="def-dashed-header">
              <BsDashLg className="dash" />
              <p>Our Recent Projects</p>
            </div>
            <div className="tagline">
              <h2>
                Looking for qualified profetionals to do construction and
                renovation in your area?
              </h2>
            </div>
          </div>
        </Grid>
        <Grid item xs={10} md={10} lg={10}>
          <Grid
            container
            justifyContent="center"
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            columnSpacing={{ xs: 1, sm: 3, md: 3 }}
            p={2}
          >
            {services_list.map((item, mainIndex) => (
              <Grid item xs={4} sm={4} md={3} key={mainIndex}>
                <div className="def-card-container">
                  <div className="def-card-image-wrapper" {...handlers}>
                    <IconButton className="btn">
                      <MdKeyboardArrowLeft
                        className="left"
                        onClick={() => prevSlide(mainIndex)}
                      />
                    </IconButton>
                    {item.images.map((image, index) => (
                      <img
                        src={image}
                        alt=""
                        key={index}
                        className={
                          index === currentIndexList[mainIndex] ? "active" : ""
                        }
                      />
                    ))}

                    <IconButton className="btn">
                      <MdKeyboardArrowRight
                        className="right"
                        onClick={() => nextSlide(mainIndex)}
                      />
                    </IconButton>
                  </div>
                  <div className="card-title">
                    <h4>{item.maintext}</h4>
                    <div className="sub-info">
                      {item.status === "completed" ? (
                        <div
                          className={
                            item.status === "completed" ? "completed" : ""
                          }
                        >
                          <IoIosCheckmark />
                          <p>{`${item.status} `}</p>
                        </div>
                      ) : (
                        <div
                          className={
                            item.status === "completed" ? "completed" : ""
                          }
                        >
                          <p>{`${item.status} `}</p>
                        </div>
                      )}

                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          marginRight: "8px",
                          opacity: 0.6,
                        }}
                      >
                        <IoLocationOutline />
                        <p style={{ textTransform: "capitalize" }}>
                          {item.location}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card-description">
                    <p>{item.subtext}</p>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ContactPage;
{
}
